// Definiere den Konami-Code als Array von Keycodes:
// 38 = ↑, 40 = ↓, 37 = ←, 39 = →, 66 = B, 65 = A
const konamiCode = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];

// Variable, um den aktuellen Fortschritt im Code zu verfolgen
let konamiIndex = 0;

// Prompt
const konamiReply = `
WELCOME HACKER :)
Get 10% off by using this link: https://go.t3n.de/forhackers
Or use discount code at checkout: FOR_HACKERS
(does not apply to discounted products)
`;
const konamiCopyText = `
FOR_HACKERS
`;

// Füge einen Event Listener für Tastendrücke hinzu
document.addEventListener("keydown", function (e) {
  // Prüfe, ob der aktuell gedrückte Keycode dem erwarteten Wert entspricht
  if (e.keyCode === konamiCode[konamiIndex]) {
    konamiIndex++;
    // Wenn der gesamte Code erfolgreich eingegeben wurde, öffne die Prompt
    if (konamiIndex === konamiCode.length) {
      prompt(konamiReply, konamiCopyText);
      // Setze den Fortschritt zurück, um den Code erneut eingeben zu können
      konamiIndex = 0;

      // Tracking hinzufügen
      dataLayer.push({ event: "konami_code" });
    }
  } else {
    // Bei falscher Eingabe wird der Fortschritt zurückgesetzt
    konamiIndex = 0;
  }
});
